import "./App.css";
import Layout from "./Components/Layout";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <>
      <Layout />
    </>
  );
}

export default App;
